import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Container, Card, Spinner, Button, Table, Col, Row, Alert } from 'react-bootstrap';
import { FaEdit, FaTrash, FaPlus, FaEye,FaArrowLeft } from 'react-icons/fa';
import { Link, useNavigate ,useParams} from 'react-router-dom';
import { getSingleProductRate} from "../rates/ratesAction";
import { getSRolePermission } from '../userRolePermission/rolepermissionAction';
import RemarkModel2 from './RemarkModel2';
import $ from 'jquery';
import moment from 'moment'
import Swal from 'sweetalert2'
import { Tooltip } from "@mui/material";


const ViewRatesPage = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {SubProductId} = useParams();
    const {name} = useParams();
    const {name2} = useParams();
    const {pid} = useParams();
    const {pname} = useParams();
    const [open, setOpen] = useState(false);
    const [selectedRowIndex, setSelectedRowIndex] = useState(null);


    const firstUpdate = useRef(true);
    const { baseid } = useSelector((state) => state.productratesList);
    

  const rates  = useSelector((state) => state.productratesList?.rates?.baseList || []);
//   const rates2 = useSelector((state) => state.productratesList?.rates?.child || {});
//   const rates3 = useSelector((state) => state.productratesList?.rates?.infant || {});
//   const rates4 = useSelector((state) => state.productratesList?.rates?.supplement || {});
//   const rates5 = useSelector((state) => state.productratesList?.rates?.promotion || {});
  console.log("rtattta",rates)
    const [isAlive,setIsAlive] = useState(true);
    //console.log(suppliers);
    const onSubProductViewRates = (id, e) => {
        e.preventDefault();
       //console.log('select role '+id);
       navigate('/viewrates/' + id + "/" + SubProductId + "/" +  name + "/" +  pid + "/" + pname); 
    }


    const onSubProductViewRates2 = (id, e) => {
        e.preventDefault();
       //console.log('select role '+id);
       navigate('/viewrates/' + id + "/" + SubProductId + "/" +  name + "/" +  pid + "/" + pname + "/" + "approval"); 
    }
 
    useEffect(() => {
        dispatch(getSingleProductRate(SubProductId));
        
    }, []);

    useEffect(() => {
        dispatch(getSRolePermission());
        
    }, []);
  
    const { permissionisLoading, combinedrolepermissiondetails } = useSelector(
        (state) => state.rolePermissionList
      );

      const filteredPermissions = combinedrolepermissiondetails.filter(
        (item) => item.label === "Add Sub Product"
      );
      
      let menu_add = 0;
      let menu_edit = 0;
      let menu_delete = 0;
      
      if (filteredPermissions.length > 0) {
        const permission = filteredPermissions[0];
        menu_add = permission.menu_add;
        menu_edit = permission.menu_edit;
        menu_delete = permission.menu_delete;
      }


    const handleOpenRemarkModel = (e) => {
        console.log("sjsjdjs",e)
        setOpen(true);
        setSelectedRowIndex(e)
        console.log("open",open)
    };
    const handleCloseRemarkModel = () => {
        setOpen(false);
        setSelectedRowIndex(null)
      };


    const onBack = () => {
   
        //console.log('select role '+id);
        if(name2){
            navigate('/SubproductListId/' + pid + "/" +pname+ "/" + "approval"); 

        }else{
            navigate('/SubproductListId/' + pid + "/" +pname); 

        }
       
     }

     const onRateModify = (id, e) => {
        e.preventDefault();
       //console.log('select role '+id);
       navigate('/modifyrates/' + id + "/" + SubProductId + "/" +  name + "/" +  pid + "/" + pname);  
   }



    if (rates.length === 0) {
        return (
            <>
            <br />
              {/* <span className="badge bg-success" onClick={onBack} style={{backgroundColor:'rgb(156 186 237)',color:'white',cursor:'pointer'}}><FaArrowLeft />&nbsp;Go Back</span><br /> */}
           
                <Container className="my-4 mx-4 container-xl">
                <table id="example" className="table table-hover table-bordered display" style={{ "width": "100%" }}>
                        <thead>
                            <tr>
                                <th style={{backgroundColor:'rgb(0 0 0 / 3%)',padding:'10px'}}><div onClick={onBack} style={{ marginLeft: '0px', marginRight: '-100px' }}><span className="badge bg-success" style={{ backgroundColor: 'rgb(156 186 237)', color: 'white' ,cursor:'pointer'}}><FaArrowLeft />&nbsp;Go Back</span></div><h4   style={{fontFamily:'Times New Roman' , fontWeight:'600'}}>Rates List</h4></th>

                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={{textAlign:'center'}}>No Data Available.</td>
                               
                            </tr>


                        </tbody>
                    </table>


              
                    {/* <h2  style={{marginLeft:'130px',marginRight:'-100px'}}>No Rates To Display.....</h2> */}

                </Container>
            </>
        );
    }


    const renderedSubProduct = rates.map((subproduct,index) => (
        
        <tr key={subproduct.id}>
             <td>{index + 1}</td>
            <td>{subproduct.from_date}</td>
            <td>{subproduct.to_date}</td>
            <td>{subproduct.status == 'Approved' ? <span className="badge bg-success"> Approved</span> : subproduct.status == 'Rejected' ? <span className="badge bg-danger" style={{cursor:"pointer"}} onClick={() => handleOpenRemarkModel(subproduct.id)}> Rejected</span>:<span className="badge bg-warning"> Pending</span>}</td>
          
           {name2 ?<td><><Tooltip title="View Rates" ><Button className="btn btn-sm btn" style={{backgroundColor:'black'}} onClick={(e) => onSubProductViewRates2(subproduct.id, e)} ><FaEye className='fwcolor' /></Button></Tooltip></></td> :
           <td style={{textAlign:'center'}}><>{menu_edit===1 &&( <Tooltip title="Edit Rates"><Button className="btn btn-sm btn-warning"  onClick={(e) => onRateModify(subproduct.id,e)}  id={subproduct.id} ><FaEdit className='fwcolor' /></Button></Tooltip>)}</></td>}
            

            {/* <Tooltip title="View Rates" ><Button className="btn btn-sm btn" style={{backgroundColor:'black'}} onClick={(e) => onSubProductViewRates(subproduct.id, e)} ><FaEye className='fwcolor' /></Button></Tooltip> */}
            
            {selectedRowIndex === subproduct.id && (
            <RemarkModel2 cdata={subproduct} cid={subproduct.id} open={open} handleClose={handleCloseRemarkModel} />

            )}
            </tr>
    ))

    





    //initialize datatable
    $(document).ready(function () {
        setTimeout(function () {
            if ($.fn.dataTable.isDataTable('#example')) {
                const table = $('#example').DataTable();
            }
            else {
                const table = $('#example').DataTable({
                    paging: true,
                    pagingType: 'full_numbers',
                    pageLength: 5,
                    processing: true,
                    dom: 'Bfrtip',
                    buttons: ['csv', 'print'],
                    // buttons: ['copy', 'csv', 'print'],
                    destroy: true,

                });
            }

        },
            1000
        );
    });
    return (
        <>

            <div className="my-4  container-xl">
                <div className="card" style={{marginTop:'-80px'}}>
                    <div className="card-header">
                        <h3 className="d-flex text-dark text-left mt-2 mb-2"  style={{fontFamily:'Times New Roman', fontWeight:'600' }}>Rates List</h3>
                    </div>
                    <div className="card-body">
                        {/* <Row>
                            <Col>
                            {pdmessage && (<Alert variant={pdstatus === "success" ? "success" : "danger"}>{pdmessage}</Alert>)}
                            </Col>
                        </Row> */}
                       <span className="badge bg-success" onClick={onBack} style={{backgroundColor:'rgb(156 186 237)',color:'white' ,cursor:'pointer'}}><FaArrowLeft />&nbsp;Go Back</span> <center><span className="badge bg" style={{backgroundColor:'rgb(156 186 237)',color:'black'}}>Sub Product Name: {name}</span></center>

                        {rates?.length
                            ? (
                                <table id="example" className="table table-hover table-bordered display" style={{ "width": "100%" }}>
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                          
                                            <th>From Date</th>
                                            <th>To Date</th>
                                            <th>Status</th>
                                            <th style={{width:'50px'}}>Action</th>
                                            
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {renderedSubProduct}


                                    </tbody>
                                </table>
                            ) : <p>No subproducts to display</p>
                        }

                    </div>
                </div>
            </div>

        </>
    )
}

export default ViewRatesPage
